const MARK = /^(\s*)(✓|✔|√|✗|✘|×|✕|FAIL\b|PASS\b)/;
const COUNT = /\b(\d+ (?:passed|passing|failed|failing))\b/g;
const TIMING = /(\s)(\d+(?:\.\d+)?\s?(?:ms|s))$/;
export function termPieces(line) {
    const out = [];
    let rest = line;
    const mark = rest.match(MARK);
    if (mark) {
        if (mark[1])
            out.push({ text: mark[1] });
        const m = mark[2];
        out.push({ text: m, tone: /✓|✔|√|PASS/.test(m) ? 'ok' : 'fail' });
        rest = rest.slice(mark[0].length);
    }
    const timing = rest.match(TIMING);
    const tail = timing ? rest.slice(0, rest.length - timing[2].length) : rest;
    let i = 0;
    for (const c of tail.matchAll(COUNT)) {
        const at = c.index ?? 0;
        if (at > i)
            out.push({ text: tail.slice(i, at) });
        out.push({ text: c[1], tone: /fail/.test(c[1]) ? 'fail' : 'ok' });
        i = at + c[1].length;
    }
    if (i < tail.length)
        out.push({ text: tail.slice(i) });
    if (timing)
        out.push({ text: timing[2], tone: 'dim' });
    // A "0 failed" count is good news, not a failure.
    for (const p of out)
        if (p.tone === 'fail' && /^0 fail/.test(p.text))
            p.tone = 'dim';
    return out.filter((p) => p.text);
}
//# sourceMappingURL=term.js.map